module.exports = "<textarea ng-model=\"fakeVM.value\"\n          ng-blur=\"applyNewValue()\"></textarea>"